import { createReducer, on } from "@ngrx/store";
import { Priority, RiskLevel, Source } from "src/app/data/models/sources/source";
import * as actions from './constants.actions';

export const featureKey = 'constants';
export interface ConstantState {
    sources: Source[];
    riskLevels: RiskLevel[];
    priorities: Priority[];
}

const constantString = localStorage.getItem('constants');
const parsed = JSON.parse(constantString) as ConstantState;


const initialState: ConstantState = {
    sources: parsed?.sources ?? [],
    riskLevels: parsed?.riskLevels ?? [],
    priorities: parsed?.priorities ?? []
};

export const reducer = createReducer(initialState,
    on(actions.prioritiesRetrieved, (state, { priority }) => ({ ...state, priorities: priority })),
    on(actions.riskLevelRetrieved, (state, { riskLevel }) => ({ ...state, riskLevels: riskLevel })),
    on(actions.sourcesRetrieved, (state, { source }) => ({ ...state, sources: source }))
)